<template>
  <div class="text-center" v-if="isLoading"><b-spinner label="Loading..." variant="primary"></b-spinner></div>
  <div v-else-if="existingActions.length > 0">
    <b-list-group class="mb-0">
      <b-list-group-item v-for="(existingAction,i) in existingActions" :key="`existing-${i}`"
                         class="d-flex justify-content-between align-items-center">
        <div>
          <font-awesome-icon v-if="existingAction.dateCompleteConfirmed" :icon="confirmIcon" :title="formatDate('Date Confirmed',existingAction.dateCompleteConfirmed)" class="text-success mr-2" />
          <font-awesome-icon v-else-if="existingAction.dateComplete" :icon="completeIcon" :title="formatDate('Date Complete',existingAction.dateComplete)" class="text-warning mr-2" />
          <font-awesome-icon v-else="existingAction.dateComplete" :icon="outstandingIcom" title="Outstanding" class="text-danger mr-2" />
        </div>
        <div class="flex-grow-1">
          {{existingAction.dateRaised | formatDate}} -
          {{existingAction.description}}
          <span v-if="existingAction.imageCount > 0">({{existingAction.imageCount}} Images <a href="#" @click="selectedActionId=existingAction.id">view</a>)</span>
          <span v-if="existingAction.completeUser"> - complete by {{existingAction.completeUser}}</span>
        </div>
        <b-button v-if="!existingAction.dateCompleteConfirmed"
                  @click="complete(existingAction)" size="sm" class="my-1"
                  :disabled="existingAction.isSaving">
          <b-spinner v-if="existingAction.isSaving" small />
          Confirm
        </b-button>
      </b-list-group-item>
    </b-list-group>
    <recommendation-images :show="selectedActionId != null" :customer-id="customerId"
                           :site-id="siteId"
                           :action-id="selectedActionId"
                           @hide="selectedActionId = null" />
  </div>
</template>

<script>
  import apiRequest from '../../JS/api-request';
  import { format, parseISO } from 'date-fns';
  import { faCheck, faExclamationTriangle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
  import { BSpinner, BCard, BButton, BListGroup, BListGroupItem } from 'bootstrap-vue';
  import RecommendationImages from './RecommendationImages.vue';

  export default {
    name: 'Recommendations',
    components: { BSpinner, BCard, BButton, BListGroup, BListGroupItem, RecommendationImages },
    filters: {
      formatDate(value) {
        if (!value) return '';
        return format(parseISO(value), 'dd MMM yyyy');
      }
    },
    data: function () {
      return {
        confirmIcon: faCheck,
        completeIcon: faInfoCircle,
        outstandingIcom: faExclamationTriangle,
        existingActions: [],
        isLoading: false,
        showImages: false,
        selectedActionId: null
      }
    },
    watch: {
      siteId() {
        this.load();
      }
    },
    props: ['customerId', 'siteId'],
    mounted() {
      this.load();
    },
    methods: {
      load() {
        var url = `/api/customers/${this.customerId}/actions`;

        if (this.siteId !== -1) {
          url = `/api/customers/${this.customerId}/sites/${this.siteId}/actions?includeComplete=true`;
        }

        apiRequest({
          method: 'get',
          url,
          busyFunc: x => this.isLoading = x,
          successFunc: x => {
            this.existingActions = x
          },
          errorMsg: 'There was an error loading actions',
          toaster: this.$bvToast
        });
      },
      async complete(action) {
        this.$set(action, 'isSaving', true);
        const result = await this.$bvModal.msgBoxConfirm('Are you sure you want to confirm this recommendation is complete?', {
          title: 'Confirmation',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        });

        if (!result) {
          this.$set(action, 'isSaving', false);
          return;
        }

        apiRequest({
          method: 'post',
          url: `/api/customers/${this.customerId}/sites/${this.siteId}/actions/${action.id}/confirm`,
          busyFunc: x => this.$set(action, 'isSaving', x),
          successFunc: x => {
            this.load();
          },
          successMsg: 'Recommendation Complete.',
          errorMsg: 'There was an error completing the action',
          toaster: this.$bvToast
        });
      },
      formatDate(text, value) {
        return `${text}: ${format(parseISO(value), 'dd MMM yyyy')}`;
      }
    }
  }
</script>
